import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import CallV2 from "../../service/axiosV2";
import {getUrl} from "../../constants/urls";

export const requestDashboardsAsync = () =>
  trackPromise(Call.get(getUrl("orgGetDashboards")));

export const requestDashboardCellsDataAsync = ({dashboard_id}) =>
  trackPromise(CallV2.get(getUrl("dashboardCells")(dashboard_id)));

export const createDashboardAsync = (data) => {
  let url = getUrl("dashboards");
  return trackPromise(CallV2.post(url, data));
};
export const updateDashboardAsync = (data) => {
  const url = `${getUrl("dashboardDetails")(data.id)}`;
  return trackPromise(CallV2.patch(url, data));
};

export const updateDashboardCellsBulkAsync = (data) => {
  const url = `${getUrl("dashboardCellsBulkUpdate")(data.id)}`;
  return trackPromise(CallV2.patch(url, data));
};

export const deleteDashboardAsync = (dashboard_id) => {
  const url = `${getUrl("dashboardDetails")(dashboard_id)}`;
  return trackPromise(CallV2.delete(url));
};

export const deleteDashboardCellAsync = (dashboard_id, cell_id) => {
  const url = `${getUrl("dashboardCellDetails")(dashboard_id, cell_id)}`;
  return trackPromise(CallV2.delete(url));
};

export const requestDashboardCellAsync = ({dashboard_id, cell_id}) => {
  return trackPromise(CallV2.get(getUrl("dashboardCellDetails")(dashboard_id, cell_id)));
};

export const getWidgetsAsync = ({customerId}) => {
  return trackPromise(Call.get(getUrl("getDashboardWidgets")(customerId)));
};

export const getQueryDataAsync = (payload) => {
  const url = getUrl("getQuery");
  return CallV2.post(url, payload);
};

export const handleSnapshotHandoffAsync = (payload) => {
  const {dashboard_id, ...data} = payload;
  const url = getUrl("snapshotHandoff")(dashboard_id);
  return trackPromise(CallV2.post(url, data));
};

export const cloneSnapshotAsync = (dashboardId) => {
  const url = getUrl("snapshotClone")(dashboardId);
  return trackPromise(CallV2.post(url));
};
